import * as React from 'react';

import { Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/admin-v2';

type ContextTypeObject = {
  [key: string]: {
    label: string;
    color: 'highlight1' | 'highlight2';
  };
};

export const CONTEXT_TYPES = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  ORG: 'org',
} as const;

type Props = {
  type: (typeof CONTEXT_TYPES)[keyof typeof CONTEXT_TYPES];
  customLabel?: string;
  style?: React.CSSProperties;
};

const ContextIndicator: React.FC<Props> = ({ type, style, customLabel }) => {
  const statusObj: ContextTypeObject = {
    public: {
      label: _t('Public'),
      color: 'highlight2',
    },
    private: {
      label: _t('Private'),
      color: 'highlight2',
    },
    org: {
      label: _t('Your Org'),
      color: 'highlight2',
    },
  };

  const contextConfig = statusObj[type];

  const { label, color } = contextConfig;

  return (
    <Tag priority="secondary" variant="category" color={color} style={style}>
      {customLabel || label}
    </Tag>
  );
};

export default ContextIndicator;
